const documents = [
  {
    title: "Anunț privind acordarea burselor pentru anul școlar 2026–2027",
    file: "Anunț privind acordarea burselor pentru anul școlar 2026-2027.PDF",
    type: "pdf",
  },
  {
    title: "Calendar burse școlare 2026–2027",
    file: "Calendar Burse scolare 2026-2027.pdf",
    type: "pdf",
  },
  {
    title: "Cerere pentru acordarea bursei sociale de venit – Word",
    file: "Cerere pentru acordarea bursei sociale de venit.docx",
    type: "docx",
  },
  {
    title: "Cerere pentru acordarea bursei sociale de venit – PDF",
    file: "Cerere pentru acordarea bursei sociale de venit.pdf",
    type: "pdf",
  },
  {
    title: "Cerere pentru acordarea bursei sociale de plasament – Word",
    file: "Cerere pentru acordarea bursei sociale de plasament.docx",
    type: "docx",
  },
  {
    title: "Cerere pentru acordarea bursei sociale de plasament – PDF",
    file: "Cerere pentru acordarea bursei sociale de plasament.pdf",
    type: "pdf",
  },
  {
    title: "Cerere pentru acordarea bursei sociale medicală – Word",
    file: "Cerere pentru acordarea bursei sociale medicală.docx",
    type: "docx",
  },
  {
    title: "Cerere pentru acordarea bursei sociale medicală – PDF",
    file: "Cerere pentru acordarea bursei sociale medicală.pdf",
    type: "pdf",
  },
  {
    title: "Cerere pentru acordarea bursei sociale pentru elevii orfani – Word",
    file: "Cerere pentru acordarea bursei sociale pentru elevii orfani.docx",
    type: "docx",
  },
  {
    title: "Cerere pentru acordarea bursei sociale pentru elevii orfani – PDF",
    file: "Cerere pentru acordarea bursei sociale pentru elevii orfani.pdf",
    type: "pdf",
  },
  {
    title: "Cerere pentru acordarea bursei pentru mame minore – Word",
    file: "Cerere pentru acordarea mame minore.docx",
    type: "docx",
  },
  {
    title: "Cerere pentru acordarea bursei pentru mame minore – PDF",
    file: "Cerere pentru acordarea mame minore.pdf",
    type: "pdf",
  },
  {
    title:
      "Declarație pe propria răspundere pentru prelucrarea datelor cu caracter personal – Word",
    file: "Declaratie pe propria raspundere pentru prelucrarea datelor cu caracter personal.docx",
    type: "docx",
  },
  {
    title:
      "Declarație pe propria răspundere pentru prelucrarea datelor cu caracter personal – PDF",
    file: "Declaratie pe propria raspundere pentru prelucrarea datelor cu caracter personal.pdf",
    type: "pdf",
  },
  {
    title:
      "Declarație pe propria răspundere privind veniturile nete ale elevului – Word",
    file: "Declaratie pe propria raspundere privind veniturile nete elev.docx",
    type: "docx",
  },
  {
    title:
      "Declarație pe propria răspundere privind veniturile nete ale elevului – PDF",
    file: "Declaratie pe propria raspundere privind veniturile nete elev.pdf",
    type: "pdf",
  },
  {
    title: "Declarație pe propria răspundere – Word",
    file: "declaratie pe propria răspundere.docx",
    type: "docx",
  },
  {
    title: "Declarație pe propria răspundere – PDF",
    file: "declaratie pe propria răspundere.pdf",
    type: "pdf",
  },
];

export default function BurseScolarePage() {
  const basePath = "/educatie/burseScolare/";

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        {/* CONȚINUT */}
        <div className="bg-white p-6 rounded shadow space-y-4">
          {documents.map((document) => {
            const documentUrl =
              basePath + encodeURIComponent(document.file);

            return (
              <div
                key={document.file}
                className="flex flex-col gap-3 border rounded-md p-4 sm:flex-row sm:items-center sm:justify-between"
              >
                <span className="font-medium text-gray-800">
                  {document.title}
                </span>

                {document.type === "pdf" ? (
                  <a
                    href={documentUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block rounded bg-blue-600 px-4 py-2 text-center text-white hover:bg-blue-700"
                  >
                    Deschide PDF
                  </a>
                ) : (
                  <a
                    href={documentUrl}
                    download
                    className="inline-block rounded bg-green-600 px-4 py-2 text-center text-white hover:bg-green-700"
                  >
                    Descarcă DOCX
                  </a>
                )}
              </div>
            );
          })}
        </div>
      </main>
    </div>
  );
}